module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedThin.1bd2e58.ttf";